module.exports = __webpack_public_path__ + "assets/img/zh4.d8113349.png";